module.exports = __webpack_public_path__ + "images/warningc17db96499f4f454b01197ec8f9b0e51.svg";